<script setup>
import useBanners from "../../use/useBanners"
import { onUpdated, defineProps, ref, defineEmits } from "vue"

const props = defineProps({
  modelValue: Boolean,
  banner: {
    required: true,
    type: Object,
  },
})

const bannerData = ref({
  id: props.banner.id,
  ads_title: props.banner.title,
  ads_link: props.banner.link,
  status: props.banner.status,
  ads_image: props.banner.image,
})

const emit = defineEmits(["update:modelValue", "close"])

const { show, loading, errors, onSubmit, closeModal } = useBanners(
  props,
  emit,
  bannerData
)

onUpdated(() => {
  bannerData.value = {
    id: props.banner.id,
    ads_title: props.banner.title,
    ads_link: props.banner.link,
    status: props.banner.status,
    ads_image: props.banner.image,
  }
})

const onFileChange = (event) => {
  bannerData.value.ads_image = event.target.files[0]
}
</script>

<template>
  <!-- edit banner modal  -->
  <b-modal
    v-model="show"
    @close="closeModal()"
    id="showModal"
    hide-footer
    title="ویرایش بنر تبلیغاتی"
    header-class="p-3 bg-light"
    class="v-modal-custom"
    centered
    no-close-on-backdrop
  >
    <b-overlay
      variant="white"
      opacity="0.75"
      blur="2px"
      :show="loading"
      spinner-variant="success"
      rounded="sm"
    >
      <b-card>
        <b-form
          id="addform"
          class="tablelist-form"
          autocomplete="off"
          @submit.prevent="onSubmit"
          enctype="multipart/form-data"
        >
          <div class="mb-3">
            <label for="title" class="form-label">عنوان بنر تبلیغاتی</label>
            <input
              type="text"
              id="title"
              class="form-control"
              placeholder="عنوان بنر تبلیغاتی"
              v-model="bannerData.ads_title"
            />
            <div v-if="errors">
              <div class="invalid-feedback" v-if="errors.ads_title">
                <span>{{ errors.ads_title[0] }}</span>
              </div>
            </div>
          </div>

          <div class="mb-3">
            <label for="link" class="form-label">لینک بنر تبلیغاتی</label>
            <input
              type="text"
              id="link"
              class="form-control"
              placeholder="لینک بنر تبلیغاتی"
              v-model="bannerData.ads_link"
            />
            <div v-if="errors">
              <div class="invalid-feedback" v-if="errors.ads_link">
                <span>{{ errors.ads_link[0] }}</span>
              </div>
            </div>
          </div>

          <div class="mb-1">
            <label for="formFile" class="form-label">تصویر</label>
            <input
              class="form-control"
              type="file"
              id="formFile"
              @change="onFileChange"
            />
            <div v-if="errors">
              <div class="invalid-feedback" v-if="errors.ads_image">
                <span>{{ errors.ads_image[0] }}</span>
              </div>
            </div>
          </div>
          <div class="mb-3">
            <img
              class="img-thumbnail"
              alt="bannerData.ads_title"
              width="75"
              :src="bannerData.ads_image"
              data-holder-rendered="true"
            />
          </div>

          <div class="mb-3">
            <label for="status-ads" class="form-label">وضعیت نمایش</label>
            <select
              class="form-select"
              id="status-ads"
              v-model="bannerData.status"
            >
              <option selected>وضعیت</option>
              <option value="0">عدم نمایش</option>
              <option value="1">نمایش</option>
            </select>
            <div v-if="errors">
              <div class="invalid-feedback" v-if="errors.status">
                <span>{{ errors.status[0] }}</span>
              </div>
            </div>
          </div>

          <div class="hstack gap-2 justify-content-end">
            <b-button
              type="button"
              id="closemodal"
              variant="light"
              @click="closeModal"
            >
              بستن
            </b-button>
            <b-button type="submit" variant="success"
              >ویرایش بنر تبلیغاتی</b-button
            >
          </div>
        </b-form>
      </b-card>
    </b-overlay>
  </b-modal>
</template>
